import {Grid, Paper} from "@mui/material";
import React from "react";
import MainMenu from "../../../components/MainMenu";
import TournamentList from "../../../components/TournamentComponents/TournamentList";

const index = () => {
    return (
        <MainMenu>
            <Grid container>
                <Grid item xs={12}>
                    <Paper elevation={3}>
                        <TournamentList/>
                    </Paper>
                </Grid>
            </Grid>
        </MainMenu>
    );
};

export default index;
